import { EULAClient } from "./types";
import { useFormeBackendApi } from "@modules/forme/queries";

const useGetClientEULA = () => {
  return useFormeBackendApi<EULAClient>({
    method: "GET",
    path: `/v1/clients/eula`,
  });
};

export { useGetClientEULA };
